import { render, staticRenderFns } from "./TifProyeccionIndex.vue?vue&type=template&id=7b92857e"
import script from "./TifProyeccionIndex.vue?vue&type=script&lang=js"
export * from "./TifProyeccionIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports